import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";


export default function Serviceadmin() {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [image, setImage] = useState(null);
  const [services, setServices] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // LOAD
  const loadServices = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allservice.php");
    const data = await res.json();
    setServices(data);
  };

  useEffect(() => {
    loadServices();
  }, []);

  // SELECT
  const handleSelect = (s) => {
    setSelectedId(s.id);
    setName(s.name);
    setTitle(s.title);
    setDetails(s.details);
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("title", title);
    formData.append("details", details);
    formData.append("image", image);

    let url = "https://drpatangecitydentalclinic.com/api/addservice.php";

    if (selectedId) {
      formData.append("id", selectedId);
      url = "https://drpatangecitydentalclinic.com/api/service_update.php";
    }

    await fetch(url, {
      method: "POST",
      body: formData,
    });

    setName("");
    setTitle("");
    setDetails("");
    setImage(null);
    setSelectedId(null);

    loadServices();
  };

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this service?")) return;

    const formData = new FormData();
    formData.append("id", id);

    await fetch("https://drpatangecitydentalclinic.com/api/deleteservice.php", {
      method: "POST",
      body: formData,
    });

    loadServices();
  };

  return (
    <div className="container-fluid p-4">
        <div className="row">
        <div className="col-md-3 col-lg-2 p-0">
          <Sidebar />
        </div>

                <div className="col-md-9 col-sm-12 col-lg-10 p-4">

      <h2 className="mb-4">Service Management</h2>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="card p-3 mb-4 shadow">

        <input
          className="form-control mb-2"
          placeholder="Service Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          className="form-control mb-2"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <textarea
          className="form-control mb-2"
          placeholder="Details"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          required
        />

        <input
          type="file"
          className="form-control mb-2"
          onChange={(e) => setImage(e.target.files[0])}
          required={!selectedId}
        />

        <button className="btn btn-primary w-100">
          {selectedId ? "Update Service" : "Add Service"}
        </button>

      </form>

      {/* TABLE */}
<div className="table-responsive">

  <table className="table table-bordered table-hover align-middle">

    <thead className="table-dark">
      <tr>
        <th>ID</th>
        <th>Image</th>
        <th>Name</th>
        <th>Title</th>
        <th style={{ minWidth: "160px" }}>Actions</th>
      </tr>
    </thead>

    <tbody>
      {services.map((s) => (
        <tr key={s.id}>

          <td>{s.id}</td>

          <td>
            <img
              src={s.image}
              alt=""
              style={{
                width: "70px",
                height: "70px",
                objectFit: "cover",
                borderRadius: "6px"
              }}
            />
          </td>

          <td style={{ minWidth: "120px" }}>{s.name}</td>

          <td style={{ minWidth: "150px" }}>{s.title}</td>

          <td>
            <button
              className="btn btn-primary btn-sm me-2 mb-1"
              onClick={() => handleSelect(s)}
            >
              Select
            </button>

            <button
              className="btn btn-danger btn-sm mb-1"
              onClick={() => handleDelete(s.id)}
            >
              Delete
            </button>
          </td>

        </tr>
      ))}
    </tbody>

  </table>

</div>
        </div>
      </div>

    </div>
  );
}